import { Doughnut, mixins } from 'vue-chartjs'
import Chart from "chart.js";
const { reactiveProp } = mixins

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: ['options'],
    mounted () {
        // this.chartData создаётся внутри миксина.
        // Если вы хотите передать опции, создайте локальный объект options
        //console.log(this.options)
        this.renderChart(this.chartData, this.options)
        this.textCenter( 'літри 880');
    },
    methods: {
        textCenter(val) {
            Chart.pluginService.register({
                beforeDraw: function(chart) {
                    var width = chart.chart.width;
                    var height = chart.chart.height;
                    var ctx = chart.chart.ctx;

                    ctx.restore();
                    var fontSize = (height / 114).toFixed(2);
                    ctx.font = fontSize + "em Roboto";
                    ctx.textBaseline = "middle";

                    var text = val;
                    var textX = Math.round((width - ctx.measureText(text).width) / 2);
                    var textY = height / 2;

                    ctx.fillText(text, textX, textY);
                    ctx.save();
                }
            });

            Chart.plugins.unregister(this.chartData);
        }
    }
}